// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2N_dj","icon__wrapper":"Header_icon__wrapper__3HUkV"};